import { Children, ReactNode } from 'react';
import { MIN_LENGTH_FOR_SEARCH_BAR } from './WorkspaceMenu.consts';

export const shouldShowSearchBar = (items: ReactNode, controlled?: boolean) => controlled ?? Children.count(items) > MIN_LENGTH_FOR_SEARCH_BAR;
